import { Globe03Icon, Lock03Icon } from '@langchain/untitled-ui-icons';

import { parseOwnerRepoCommit } from '@/components/Rules/RulesEvaluatorPane.utils';
import { RepoWithLookupsSchema } from '@/types/schema';
import { cn } from '@/utils/tailwind';

export function getPromptDisplayName(
  isPublic: boolean,
  fullName: string,
  promptName: string,
  commitHash?: string
): string {
  const nameString = isPublic ? fullName : promptName;
  return commitHash
    ? `${nameString}:${commitHash.substring(0, 8)}`
    : nameString;
}

export function getPromptDisplayNameFromRepoObj(
  repo: RepoWithLookupsSchema,
  commitHash?: string
): string {
  return getPromptDisplayName(
    repo.is_public,
    repo.full_name,
    repo.repo_handle,
    commitHash
  );
}

export const getPromptDisplayNameForSelector = (
  prompt?: RepoWithLookupsSchema
) => {
  if (!prompt) return undefined;
  const [owner, promptName, _] = prompt
    ? parseOwnerRepoCommit(prompt.full_name)
    : [];
  return prompt.is_public ? `${owner}/${promptName}` : promptName;
};

export function getPromptIcon(
  isPublic: boolean,
  className?: string
): JSX.Element {
  const baseClass = 'h-4 w-4 my-auto shrink-0';
  if (isPublic) {
    return <Globe03Icon className={cn(baseClass, className)} />;
  } else {
    return <Lock03Icon className={cn(baseClass, className)} />;
  }
}
